<template>
    <div class="driving-address-picker">
        <div class="driving-address-content" @click="onOpen()">
            <div class="input-box" :class="{'with-placeholder': !(selectedSite || selectedCity), readonly}">
                <span v-if="!(selectedSite || selectedCity)">{{placeholder}}</span>
                <span v-else-if="!selectedSite">{{selectedCity.city_name}}</span>
                <div class="site-info" v-else>
                    <span class="nearest-tag" v-if="showNearestTag&&selectedSite.nearest">最近</span>
                    <span class="name">{{selectedSite.name}}</span>
                    <div class="distance" v-if="showDistance&&selectedSite.distance && selectedSite.distance <= 5000">
                        <span>{{selectedSite.distance | distance }}</span>
                    </div>
                </div>
            </div>
            <div class="ico-box"><img src="../../../../assets/images/icon_arrows_right.png" /></div>
        </div>
        <div class="driving-address-model" v-show="isShow">
            <div class="driving-address-model-mask" @click="onClose"></div>
            <div class="driving-address-model-content">
                <div class="driving-address-model__header">
                    <label class="title">请选择</label>
                    <span class="close" @click="onClose"></span>
                </div>
                <div class="driving-address-model__body">
                    <div class="tab-box" :class="{'no-border': tabIndex === 2}">
                        <div class="tabs" :class="{'selected': tabIndex === 0, 'placeholder': !provinceName}" @click="toChooseProvince">{{provinceName || "请选择省份"}}</div>
                        <div v-show="provinceID" class="triangle-right"></div>
                        <div v-show="provinceID" class="tabs" :class="{'selected': tabIndex === 1, 'placeholder': !cityName}"  @click="toChooseCity">{{cityName || '请选择市/区'}}</div>
                        <div v-show="cityID && sites.length" class="triangle-right"></div>
                        <div v-show="cityID && sites.length" class="tabs" :class="{'selected': tabIndex === 2, 'placeholder': !siteName}" @click="toChooseSite">{{siteName || '请选择门店'}}</div>
                    </div>
                    <div class="region-transform" :style="{transform: transformStyle}">
                        <div class="listbox">
                            <div class="list">
                                <template v-for="unit in letter">
                                    <div class="dd left-padding" :class="{'selected': provinceID === item.id}" @click="onSelectProvince(item)" v-for="(item, index) in provinceList[unit]" :key="index + unit">
                                        <span class="name">{{item.name}}</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="listbox">
                            <div class="list">
                                <template v-for="unit in letter">
                                    <div class="dd left-padding" :class="{'selected': cityID === item.city_id}" @click="onSelectCity(item)" v-for="(item, index) in citiyList[unit]" :key="index + unit">
                                        <span class="name">{{item.city_name}}</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="listbox">
                            <div class="list">
                                <div class="dd left-padding" @click="onSelectSite(item)" v-for="item in sites" :key="item.id">
                                    <div class="site-card" :class="{'selected': siteID === item.id}">
                                        <div class="site-card__header site-info">
                                            <span class="nearest-tag" v-if="item.nearest">最近</span>
                                            <span class="name">{{item.name}}</span>
                                            <div class="distance" v-if="item.distance && item.distance <= 5000">
                                                <span>{{item.distance | distance }}</span>
                                            </div>
                                        </div>
                                        <div class="site-card__body">{{item.detail_address}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import makePy from '@/util/make-py';
import { stopBodyScroll } from '@/util/dom';

const mixin = {
    methods: {
        ...mapActions('marketing/', ['getGisAreaList']),
        ...mapActions('atDriver/', ['getDrivingAddressList'])
    }
};

export default {
    mixins: [mixin],
    props: {
        placeholder: {
            type: String,
            default: '请选择期望门店'
        },
        readonly: {
            type: Boolean,
            default: false
        },
        lat: Number,
        lng: Number,
        showNearestTag: {
            type: Boolean,
            default: true
        },
        showDistance: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isShow: false,
            letter: 'ABCDEFGHIJKMLNOPQRSTUVWXYZ',
            arrowImg: require('@/assets/images/right_arrow.png'),
            // 选择省份name
            provinceName: '',
            provinceID: '',
            // 城市id
            cityID: '',
            cityName: '',
            // 试驾点
            siteID: '',
            siteName: '',
            // 切换样式
            transformStyle: '',
            provinces: [],
            gisProvinces: [],
            selectedCities: [],
            sites: [],
            tabIndex: 0,
            selectedSite: null,
            selectedCity: null
        };
    },
    mounted() {
        this.loadGisProvinces();
    },
    methods: {
        async loadGisProvinces() {
            return this.getGisAreaList().then(({ data }) => {
                this.gisProvinces = (data.provinces || []).map(x => ({
                    id: +x.areaCode,
                    name: x.name,
                    cities: (x.cities || []).map(y => ({
                        city_id: +y.areaCode,
                        city_name: y.name
                    }))
                }));
            });
        },
        async selectDefaultSite(area_code, site_id) {
            if (!area_code && !site_id) {
                return {};
            }
            const province = String(area_code).replace(/[0-9]{4}$/, '0000');
            if (!this.gisProvinces.length) {
                await this.loadGisProvinces();
            }
            const provinceObj = this.gisProvinces.find(
                i => String(i.id) === String(province)
            );
            this.provinceName = provinceObj.name;
            this.provinceID = provinceObj.id;
            this.selectedCities = provinceObj.cities;
            let transformStyle = 'translate3d(-100vw, 0px, 0px)';
            const cityObj = (provinceObj.cities || []).find(
                i => String(i.city_id) === String(area_code)
            );
            this.cityID = cityObj ? cityObj.city_id : '';
            this.cityName = cityObj ? cityObj.city_name : '';
            const sitesRes = await this.getDrivingAddressList({
                area_code,
                lat: this.lat,
                lng: this.lng
            });

            this.sites = sitesRes.data || [];
            if (this.sites && this.sites.length) {
                transformStyle = 'translate3d(-200vw, 0px, 0px)';
                let siteObj = this.sites.find(
                    i => String(i.id) === String(site_id)
                );
                if (!siteObj) {
                    siteObj = this.sites[0];
                }
                this.siteID = siteObj.id;
                this.siteName = siteObj.name;
                this.tabIndex = 2;
                this.selectedCity = null;
                this.selectedSite = siteObj;
                this.$emit('onConfirm', {
                    city_id: this.cityID,
                    city_name: this.cityName,
                    province_id: this.provinceID,
                    province_name: this.provinceName,
                    site_id: siteObj.id,
                    site_name: siteObj.name,
                    site_distance: siteObj.distance,
                    no_track: true
                });
            } else {
                this.siteName = '';
                this.tabIndex = 1;
                this.selectedSite = null;
                this.selectedCity = cityObj;
                this.$emit('onConfirm', {
                    city_id: this.cityID,
                    city_name: this.cityName,
                    province_id: this.provinceID,
                    province_name: this.provinceName,
                    no_track: true
                });
            }
            this.transformStyle = transformStyle;
            return {
                ...(this.selectedSite || {}),
                city_name: this.cityName,
                city_id: this.cityID
            };
        },
        // 选择省
        onSelectProvince(param) {
            this.provinceName = param.name;
            this.provinceID = param.id;
            this.cityID = '';
            this.cityName = '';
            this.siteID = '';
            this.siteName = '';

            const selectedProvince = this.gisProvinces.find(
                x => String(x.id) === String(param.id)
            );

            if (selectedProvince && selectedProvince.cities) {
                this.selectedCities = selectedProvince.cities;
            } else {
                this.selectedCities = [];
            }
            this.transformStyle = 'translate3d(-100vw, 0px, 0px)';
            this.tabIndex = 1;
        },
        // 选择试驾点
        onSelectCity(param, triggerClose = true) {
            this.cityID = param.city_id;
            this.cityName = param.city_name;
            this.siteID = '';
            this.siteName = '';
            return this.getDrivingAddressList({
                area_code: param.city_id,
                lat: this.lat,
                lng: this.lng
            }).then(({ data = [] }) => {
                this.sites = data;
                if (data && data.length) {
                    this.transformStyle = 'translate3d(-200vw, 0px, 0px)';
                    this.tabIndex = 2;
                } else {
                    this.selectedSite = null;
                    this.selectedCity = param;
                    this.$emit('onConfirm', {
                        city_id: this.cityID,
                        city_name: this.cityName,
                        province_id: this.provinceID,
                        province_name: this.provinceName
                    });
                    if (triggerClose) {
                        this.$nextTick(() => {
                            this.onClose();
                        });
                    }
                }
            });
        },
        onSelectSite(param, triggerClose = true) {
            this.siteID = param.id;
            this.siteName = param.name;
            this.selectedSite = param;
            this.selectedCity = null;
            this.$emit('onConfirm', {
                city_id: this.cityID,
                city_name: this.cityName,
                province_id: this.provinceID,
                province_name: this.provinceName,
                site_id: param.id,
                site_name: param.name,
                site_distance: param.distance
            });
            if (triggerClose) {
                this.$nextTick(() => {
                    this.onClose();
                });
            }
        },
        toChooseProvince() {
            this.transformStyle = '';
            // this.cityID = '';
            // this.cityName = '';
            // this.siteID = '';
            // this.siteName = '';
            this.tabIndex = 0;
        },
        toChooseCity() {
            this.transformStyle = 'translate3d(-100vw, 0px, 0px)';
            // this.siteID = '';
            // this.siteName = '';
            this.tabIndex = 1;
        },
        toChooseSite() {
            if (this.siteID) {
                this.transformStyle = 'translate3d(-200vw, 0px, 0px)';
                this.tabIndex = 2;
            }
        },
        onOpen() {
            stopBodyScroll(true);
            this.isShow = true;
            this.$emit('onOpen');
        },
        onClose() {
            stopBodyScroll(false);
            this.isShow = false;
        },
        // 返回首字母
        getPy(value) {
            if (value) {
                const chList = makePy(value);
                if (chList.length > 0) {
                    return chList[0].charAt(0);
                }
            }
            return ' ';
        },
        // 返回a～z顺序列表
        formatList(list) {
            const newList = [];
            for (const item of list) {
                const unit = this.getPy(item.name || item.city_name);
                const obj = {
                    first: unit,
                    ...item
                };
                newList[unit]
                    ? newList[unit].push(obj)
                    : (newList[unit] = [obj]);
            }
            return newList;
        },
        getStyle(dom, attr) {
            if (dom.currentStyle) {
                return dom.currentStyle[attr];
            } else {
                return document.defaultView.getComputedStyle(dom, null)[attr];
            }
        }
    },
    computed: {
        provinceList() {
            const list = this.gisProvinces;
            return this.formatList(list);
        },
        citiyList() {
            const list = this.selectedCities;
            return this.formatList(list);
        }
    },
    filters: {
        distance: function(value) {
            if (!value) return '';
            return `${Math.round(value / 10) / 100}KM`;
        }
    }
};
</script>

<style lang="less" scoped>
@import '~src/assets/css/mixin.less';
@import '~src/assets/css/variable.less';
.line-height(@h) {
    height: @h * @layout375;
    line-height: @h * @layout375;
}
.left-padding() {
    padding-left: 20 * @layout375;
}
.right-padding() {
    padding-right: 20 * @layout375;
}
.left-padding {
    .left-padding();
}
.with-placeholder {
  color: #9B9DA9;
}
.site-info {
    display: flex;
    align-items: center;
    .name {
        font-size: 16 * @layout375;
        color: #040B29;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .nearest-tag {
        display: inline-block;
        line-height: 20 * @layout375;
        padding: 0 5 * @layout375;
        background-color: #F2FCFC;
        color: #009292;;
        font-size: 12 * @layout375;
        margin-right: 8 * @layout375;
        min-width: fit-content;
    }
    .distance {
        flex: 1;
        font-size: 12 * @layout375;
        color: #9B9DA9;
        line-height: 18 * @layout375;
        text-align: right;
    }
}

.driving-address-picker {
    width: 100%;
    .driving-address-content {
        position: relative;
        display: flex;
        .input-box {
            flex: 1;
            width: 0;
            input::-webkit-input-placeholder {
                color: #9B9DA9!important;
            }
        }
        .ico-box {
            width: 20 * @layout375;
            margin-left: 5 * @layout375;
            text-align: right;
            display: flex;
            align-items: center;
            img {
                width: 90%;
            }
        }
        .cover-box {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 2;
            top: 0;
        }
    }
    .driving-address-model {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0;
        padding: 0;
        font-size: 15px;
        z-index: 999;
        .icon-check {
            color: #00bcbc;
        }
        .driving-address-model-content {
            display: flex;
            flex-direction: column;
            background: #fff;
            position: relative;
            position: fixed;
            bottom: 0;
            top: 50 * @layout375;
            z-index: 1001;
            .driving-address-model__header {
                position: relative;
                padding: 20 * @layout375;
                font-size: 18 * @layout375;
                line-height: 25 * @layout375;
                font-weight: 500;
                color: #040B29;
                .close {
                    position: absolute;
                    right: calc(200vw + (25 * @layout375));
                    top: 50%;
                    transform: translate3d(0, -50%, 0);
                    width: 16 * @layout375;
                    height: 16 * @layout375;
                    background-position: center;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-image: url(~src/assets/images/icon-close.png);
                }
            }
            .driving-address-model__body {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }
            .tab-box {
                display: flex;
                position: relative;
                font-size: 14 * @layout375;
                line-height: 30 * @layout375;
                .left-padding();
                margin-bottom: 30 * @layout375;
                .tabs {
                    color: #040B29;
                    &.selected {
                        color: #00bebe;
                    }
                    &.placeholder {
                        color: #CDCED4;
                    }
                }
                .triangle-right {
                    width: 0;
                    height: 0;
                    margin: 12 * @layout375 7 * @layout375 12 * @layout375 10  * @layout375;
                    border-width: 3 * @layout375 6 * @layout375 ;
                    border-style: solid;
                    border-color: transparent;
                    border-left-color: #CDCED4;
                }
                &::after {
                    position: absolute;
                    left: 20 * @layout375;
                    width: calc(100vw - 40 * @layout375);
                    bottom: -20 * @layout375;
                    content: '';
                    border-bottom: 1px solid #E9ECF1;
                }
                &.no-border::after {
                    display: none;
                }
            }
            .region-transform {
                flex: 1;
                display: flex;
                transition: all 0.3s ease-in-out;
                transform: translate3d(0px, 0px, 0px);
                overflow: hidden;
                .listbox {
                    width: 100vw;
                    height: 100%;
                    padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
                    padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
                    overflow: auto;
                    .list {
                        .flexbox(column);
                        .dd {
                            font-size: 14 * @layout375;
                            line-height: 20 * @layout375;
                            padding: 10 * @layout375 20 * @layout375;
                            &.selected {
                                color: #00bebe;
                            }
                        }
                    }
                }
            }
            .site-card {
                padding: 12 * @layout375;
                border: 1 * @layout375 solid #E9ECF1;
                &.selected {
                    border-color: #040B29;
                }
                .site-card__header {
                    line-height: 20 * @layout375;
                    .name {
                        font-size: 14 * @layout375;
                    }
                }
                .site-card__body {
                    margin-top: 10 * @layout375;
                    font-size: 12 * @layout375;
                    line-height: 17 * @layout375;
                    color: #9B9DA9;
                }
            }
        }
        .driving-address-model-mask {
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background: rgba(0, 0, 0, 0.3);
            z-index: 1000;
            text-align: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/marketing_components/form/picker/driving-address-picker/index.vue